import { render } from "./ThePortfolios.vue?vue&type=template&id=3238e598&scoped=true"
import script from "./ThePortfolios.vue?vue&type=script&lang=js"
export * from "./ThePortfolios.vue?vue&type=script&lang=js"

import "./ThePortfolios.vue?vue&type=style&index=0&id=3238e598&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3238e598"]])

export default __exports__